package com.kinoshazam.uiKit.components.carousel

import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.graphics.painter.Painter
import com.kinoshazam.uiKit.theme.UiKitTheme

/**
 * Carousel prev/next control: [color_7] by default, [color_1] on hover when enabled,
 * muted [color_16] when disabled (no hover highlight).
 */
@Composable
fun CarouselNavButton(
    painter: Painter,
    enabled: Boolean,
    contentDescription: String,
    onClick: () -> Unit,
) {
    val interactionSource = remember(enabled) { MutableInteractionSource() }
    val isHovered by interactionSource.collectIsHoveredAsState()
    val tint = when {
        !enabled -> UiKitTheme.colors.color_16
        isHovered -> UiKitTheme.colors.color_1
        else -> UiKitTheme.colors.color_7
    }

    IconButton(
        onClick = onClick,
        enabled = enabled,
        interactionSource = interactionSource,
    ) {
        Icon(
            painter = painter,
            tint = tint,
            contentDescription = contentDescription,
        )
    }
}
